class SearchPanel extends Panel {
  connectedCallback() {
    super.connectedCallback();
    this.defaultFocus = this.querySelector('input');
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    header.classList.add('desktop-drawer-open');
    if (!triggerElement.dataset.mobileTrigger) {
      triggerElement.classList.add('!text-black');
    }
    if (previousState === 'idle') {
      this.activate();
      requestAnimationFrame(() => {
        this.animateDrawerOpen().then(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      });
    } else if (previousState === 'shopActive') {
      header.querySelectorAll('[data-panel-transition]').forEach((x) => {
        x.classList.remove('!text-black');
      });
      triggerElement.classList.add('!text-black');
      previousPanel.deactivate();
      if (drawerWrapperElement.classList.contains('level-2-active')) {
        drawerWrapperElement.classList.remove('level-2-active');
        waitForTransitionEnd(drawerWrapperElement, 'width').then(() => {
          this.activate();
          requestAnimationFrame(() => {
            window.trapFocus(this, this.defaultFocus, triggerElement);
          });
        });
      } else {
        this.activate();
        requestAnimationFrame(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      }
    }
  }

  animateDrawerOpen() {
    return new Promise((resolve) => {
      header.classList.add('desktop-drawer-open');
      maskElement.show();
      drawerElement.className =
        'drawer-inner transition-all absolute inset-y-0 z-75 w-full -translate-x-full bg-white duration-600 tablet:w-25';
      // un-hide container
      drawerWrapperElement.classList.remove('hidden');
      // set transition state
      requestAnimationFrame(() => {
        drawerElement.classList.remove('-translate-x-full');
        maskElement.classList.replace('opacity-0', 'opacity-60');
      });
      drawerElement.addEventListener('mouseover', mouseOverDrawer);
      waitForTransitionEnd(maskElement).then(() => {
        resolve();
      });
    });
  }
}
customElements.define('search-panel', SearchPanel);
